import { render, staticRenderFns } from "./UserSubject.vue?vue&type=template&id=4db1d5b2&scoped=true"
import script from "./UserSubject.ts?vue&type=script&lang=ts&external"
export * from "./UserSubject.ts?vue&type=script&lang=ts&external"
import style0 from "./user-subject.scss?vue&type=style&index=0&id=4db1d5b2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db1d5b2",
  null
  
)

export default component.exports